import script from "./DocumentEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentEditor.vue?vue&type=script&setup=true&lang=js"

import "./DocumentEditor.vue?vue&type=style&index=0&id=87333262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87333262"]])

export default __exports__